export default __webpack_public_path__ + "static/media/pagination_button_left.f413af74.svg";